import React, { useEffect, useMemo, useRef, useState } from "react";
import CustomIcons from "../../icons/kIcons.component";
import Loader from "../../loader/loader";
import CheckBox from "../../inputs/checkbox";
import "./compDirectory.style.css";
import SearchButton from "../../inputs/searchButton";
import MoreDetails from "./moreDetails/moreDetails";
import Pagination from "./companyPagination";
import BreadCrumpBack from "../../navigator/back";

export default function CommonCompanyDirectory(props) {
  const [pageSize, setPageSize] = useState(props.perPage || 6);
  const [currentPage, setCurrentPage] = useState(1);
  const [showTopFilters, setShowTopFilters] = useState(false);
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);

  const mainData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    const filtered = props.showStatus7
      ? props.data || []
      : (props.data || []).filter(item => item.application_status !== 7);
    return filtered.slice(firstPageIndex, lastPageIndex);
  }, [props.data, currentPage, pageSize, props.showStatus7]);

  const [domain, setDomain] = useState(props.domain);
  const [openView, setOpenView] = useState(false);
  const [activeData, setActiveData] = useState({});
  const myRef = useRef(null);
  const searchChange = (e) => {
    const v = e.target.value;
    props.setSearch(v);
    props.setQsearch(v);
  };
  const submitSearch = () => {
    // props.searchCompanies();
    props.setQsearch(props.search);
  };
  const clearSearch = () => {
    props.setSearch("");
    props.setQsearch("");

    // props.searchCompanies();
    // submitSearch()
  };
  const handleNav = (d, a) => {
    // //console.log(d.startsWith("https"))
    if (d.startsWith("https://")) {
      window.open(`${d}`, "_blank");
    } else {
      window.open(`https://${d}`, "_blank");
    }
  };
  const handleViewDetails = (item) => {
    setOpenView(true);
    setActiveData(item);
  };
  const handleViewClose = () => {
    setOpenView(false);
    setActiveData({});
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    myRef.current.scrollIntoView();
  };
  // Responsive page size: 8 on large screens, otherwise keep provided perPage
  useEffect(() => {
    const computeSize = () => {
      const isLarge = typeof window !== 'undefined' && window.innerWidth >= 1025;
      setPageSize(isLarge ? 6 : (props.perPage || 6));
    };
    computeSize();
    window.addEventListener('resize', computeSize);
    return () => window.removeEventListener('resize', computeSize);
  }, [props.perPage]);
  useEffect(() => {
    setDomain(props.domain);
  }, [props.domain, props.key]);
  return (
    <div ref={myRef}>
      <div className="">
        <Loader open={props.isActive} />
        <div>
          <div className="dash-banner">
            <div className="tit-txt">{props.title}  </div>
          </div>
        </div>
        <BreadCrumpBack />

        <div className="comp-layout-con">
          {/* <CustomIcons iconName="edit" iconClass=""/> */}
          {/* Top filter bar */}
          <div className="top-filter-wrap">
            <div className="filter-bar-actions">
              <button
                className="filter-toggle-btn"
                onClick={() => setShowTopFilters((s) => !s)}
              >
                <CustomIcons iconName="filter" /> Filters by Domain
              </button>
              <div className="comp-search-box" style={{ flex: 1, marginLeft: 12 }}>
                <SearchButton
                  type="text"
                  onChange={searchChange}
                  clearSearch={clearSearch}
                  value={props.search}
                  placeholder={"Search by Company"}
                  showSearchIcon={false}
                />
              </div>
            </div>
            <div className={`filter-bar ${showTopFilters ? 'open' : ''}`}>
              <div className="filter-bar-inner">
                {domain?.map((item) => (
                  <CheckBox
                    key={item.id || item.domain_name}
                    className="domaincheck"
                    label={item.domain_name}
                    checked={item.checked ? true : false}
                    onChange={(e) => {
                      props.FilterChange(e, item);
                    }}
                  />
                ))}
                <div className="com-sel-filters" style={{ paddingTop: 0 }}>
                  {props.domain.map((item) => (
                    item.checked && (
                      <div key={item.id || item.domain_name} className="comp-filter-item">
                        <div className="comp-filter-item-label">
                          {item.domain_name}
                        </div>
                        <div
                          className="filter-clearButton-cont"
                          onClick={() => props.closeFilter(item)}
                        >
                          <CustomIcons
                            iconName="clearInput"
                            iconClass={"filter-clear-button"}
                          />
                        </div>
                      </div>
                    )
                  ))}
                </div>
                <div className="filter-bar-footer">
                  <button
                    type="button"
                    className="clear-filter-btn"
                    onClick={() => { props.clearFilter(); setShowTopFilters(false); }}
                  >
                    <CustomIcons iconName="clearInput" />
                    Clear Filter
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Listing */}
          <div className="comp-outer-cont">
            <div className="com-dir-cont">
              <div className="comp-list-con">
                {mainData && mainData.length !== 0 ? (
                  <>
                    {mainData?.map((item) => (
                      item?.company_name !== "NDF10display" && (
                        <div key={item.id || item.company_name} className="comp-list-item-cont">
                          <div className="comp-list-item">
                            <div className="comp-item-comp-title">
                              {item.company_name
                                ? item.company_name.charAt(0).toUpperCase() + item.company_name.slice(1)
                                : ""}
                            </div>
                            <div className="comp-item-header">
                              {item?.logo ? (
                                <div className="comp-item-logo">
                                  <img
                                    className="comp-item-img-logo"
                                    alt=""
                                    src={`${result}/${item?.logo}`}
                                  />
                                </div>
                              ) : (
                                <div className="comp-item-logo" style={{ minWidth: "120px" }}>
                                  {item?.company_name?.substring(0, 1)}
                                </div>
                              )}

                              <div className="comp-item-header-data">
                                <div className="comp-item-person-name">
                                  {item.person_name}
                                  {/* {item.company_name} */}
                                </div>

                                <div className="d-flex">
                                  <div>
                                    <CustomIcons
                                      iconName="mail"
                                      iconClass="comp-item-data-icons"
                                    />
                                  </div>
                                  <div className="text-break">
                                    {item.email}
                                  </div>
                                </div>

                                {item.ex_man_power &&
                                  item.ex_man_power !== "null" && (
                                    <div className="d-flex">
                                      <div>
                                        <CustomIcons
                                          iconName="people"
                                          iconClass="comp-item-data-icons"
                                        />
                                      </div>
                                      <div className="text-break">
                                        {item.ex_man_power}
                                      </div>
                                    </div>
                                  )}
                                {item?.site_link && (
                                  <div
                                    className="d-flex "
                                    style={{ cursor: "pointer" }}
                                  >
                                    <div>
                                      <CustomIcons
                                        iconName="globe"
                                        iconClass="comp-item-data-icons"
                                      />
                                    </div>
                                    <div
                                      className="text-break"
                                      onClick={() =>
                                        handleNav(item?.site_link)
                                      }
                                    >
                                      {item?.site_link}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Domain chips */}
                            {(item.any_other_domain || (item.domain_types && item.domain_types.length)) && (
                              <div className="comp-item-dom-cont" style={{ marginTop: 10 }}>
                                {item.any_other_domain && (
                                  <span className="chip">#{item.any_other_domain}</span>
                                )}
                                {item.domain_types?.map((dom, i) => (
                                  <span key={`${dom.domain_name}-${i}`} className="chip">#{dom.domain_name}</span>
                                ))}
                              </div>
                            )}

                            {/* <div className="comp-item-dom-cont">
                                {item.any_other_domain !== null &&
                                  item.any_other_domain !== "" &&
                                  item.any_other_domain !== undefined && (
                                    <div className="comp-item-dom">
                                      {`#${item.any_other_domain}`}
                                    </div>
                                  )}
                                {item.domain_types?.map((dom) => (
                                  <div className="comp-item-dom">
                                    {`#${dom.domain_name}`}
                                  </div>
                                ))}
                              </div> */}
                            <div className="comp-item-product-prof-cont">
                              <b>Product Profile</b>

                              {item.product_profiles?.map((produ, index) => (
                                <div key={produ.id || index}>
                                  <div className="comp-item-prod-prof-title">
                                    {index + 1}.&nbsp;
                                    {produ.product_name}
                                  </div>

                                </div>
                              ))}
                            </div>
                            <div className="comp-view-more-cont">
                              <div
                                className="comp-item-view-more-text"
                                onClick={(e) => handleViewDetails(item)}
                              >
                                View Details
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    ))}
                  </>
                ) : (
                  <div className="no-data-found">No Results found</div>
                )}
              </div>
            </div>
          </div>
          <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={props.data.length}
            pageSize={pageSize}
            onPageChange={(page) => handlePageChange(page)}
          />
        </div>
      </div>
      <MoreDetails
        open={openView}
        data={activeData}
        handleClose={handleViewClose}
        india={props?.india}
      />
    </div>
  );
}
